export default __webpack_public_path__ + "static/media/devguide14.8a80bad6.md";